import { useQuery } from "react-query";
import { getDNMDataReport } from "../Requests/getDNMData";

export default function useGetDNMDataReport(params) {
  return useQuery({
    queryKey: ["getDNMReport", params],
    queryFn: () => getDNMDataReport(params),
    enabled: false,
  });
}
